import {NavLink} from 'react-router-dom';
import { NavLinks } from '../utils/constants';
import '../styles/homeStyles.css'


// Consider - changing Link to NavLink reference - https://hygraph.com/blog/routing-in-react
function NavBar () {
    return (
        <nav className="navbar">
            <ul className="nav-links">
                {NavLinks.map((link) => (
                    <li className="nav-item" key={link.key}>
                        <a href={link.href}>
                            {link.text}
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    )
}

export default NavBar;

